import { atom, useAtom } from "jotai";
import { ExpensesItem } from "types";

export type ExpensesItemsState = {
  activeItem: ExpensesItem | null;
};

type UseExpensesStateReturn = {
  expensesState: ExpensesItemsState;
  setExpensesState: React.Dispatch<React.SetStateAction<ExpensesItemsState>>;
};

export const expensesStateAtom = atom<ExpensesItemsState>({
  activeItem: null,
});

export const useExpensesState = (): UseExpensesStateReturn => {
  const [expensesState, setExpensesState] = useAtom(expensesStateAtom);

  return { expensesState, setExpensesState };
};
